import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-link-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33333 10.8333C8.69121 11.3117 9.14775 11.7075 9.67206 11.9941C10.1964 12.2807 10.7762 12.4516 11.3722 12.4953C11.9681 12.5391 12.5665 12.4546 13.1271 12.2477C13.6878 12.0407 14.1975 11.7161 14.6217 11.2958L17.1217 8.79583C17.8838 8.00674 18.3056 6.94989 18.2961 5.85291C18.2865 4.75592 17.8464 3.70657 17.0707 2.93085C16.295 2.15514 15.2456 1.71503 14.1486 1.70549C13.0517 1.69595 11.9948 2.11774 11.2057 2.87986L9.77237 4.30486"
        [attr.stroke]="color"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.6667 9.16665C11.3088 8.68821 10.8523 8.29245 10.328 8.00584C9.80364 7.71923 9.22385 7.54834 8.62788 7.5046C8.03191 7.46085 7.43351 7.54527 6.87286 7.75223C6.31221 7.95919 5.80252 8.28379 5.37837 8.70415L2.87837 11.2041C2.11625 11.9932 1.69446 13.0501 1.704 14.1471C1.71353 15.2441 2.15365 16.2934 2.92936 17.0691C3.70508 17.8449 4.75443 18.285 5.85141 18.2945C6.9484 18.304 8.00525 17.8823 8.79434 17.1201L10.2193 15.6951"
        [attr.stroke]="color"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
})
export class LinkIcon extends BaseIconComponent {}
